import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { Box, Button, Checkbox, Typography } from "@mui/material";
import { FC, useState } from 'react';
import { Link } from 'react-router-dom';
import { ITheme } from "../../utils/theme";
import { OrderPickupExtraNotes } from "./CurrentDispatchData";
import { HAVE_CONFIRMED_SUBTITLE } from "./CurrentDispatchModels";
import { haveConfirmedSubtitleStyle, notesWrapperStyle, viewReceiptIconStyle, viewReceiptStyle } from "./styled";

interface CurrentDispatchNotesProps {
  note: OrderPickupExtraNotes;
  handleSubmit: (e: React.MouseEvent) => void;
  isTelephoneBoard: boolean;
  orderDetailId: number;
}

export const CurrentDispatchNotes: FC<CurrentDispatchNotesProps> = ({
  note: { title, message, showAcceptDespatch, subTitle, subMessage },
  handleSubmit,
  isTelephoneBoard,
  orderDetailId
}) => {
  const [accepted, setAccepted] = useState<boolean>(false);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAccepted(event.target.checked);
  };

  /*
    The haveConfirmedSubtitle constant stores the substring value that should be green. 
    Since we received the message and header as a single string from the server, 
    we need to remove this substring from the message string.
  */
  const haveConfirmedSubtitle = message.includes(HAVE_CONFIRMED_SUBTITLE);
  const messageText = haveConfirmedSubtitle ? message.replace(HAVE_CONFIRMED_SUBTITLE, '') : message;
  const showViewReceipt = isTelephoneBoard && haveConfirmedSubtitle;
  return (
    <Box sx={notesWrapperStyle}>
      <Typography className="bold">{title}</Typography>
      {haveConfirmedSubtitle && <Typography sx={haveConfirmedSubtitleStyle}>
        {HAVE_CONFIRMED_SUBTITLE}
      </Typography>}
      <Typography sx={{ marginBottom: 1 }}>{messageText}</Typography>
      {subTitle && <Typography className="bold">{subTitle}</Typography>}
      {subMessage && <Typography sx={{ marginBottom: 1 }}>{subMessage}</Typography>}
      {showAcceptDespatch && <Box>
        <Typography sx={{ display: 'flex', alignItems: 'center' }} className="bold">
          <Checkbox checked={accepted} onChange={handleCheckboxChange} />
          I accept this dispatch job position
        </Typography>
        <Typography sx={{ textAlign: 'right' }}>
          <Button
            onClick={handleSubmit}
            variant="contained"
            color="primary"
            disabled={!accepted}
          >
            Submit Order Pickup
          </Button>
        </Typography>
      </Box>}
      {showViewReceipt && (
        <Link to={`/dispatch-confirmation-receipt/${orderDetailId}`} style={viewReceiptStyle} target="_blank">
          <ReceiptLongIcon sx={viewReceiptIconStyle} />
          <Typography sx={{ color: (theme: ITheme) => theme.palette.blue[900] }}>VIEW RECEIPT</Typography>
        </Link>
      )}
    </Box>
  )
}